import { combineReducers } from 'redux';
import { cart } from './Reducers/Cart.reducer';
import { bulkAddToCart } from './Reducers/BulkAddToCart.reducer';
import { quickSearch } from './Reducers/QuickSearch.reducer';
import { navigation } from './Reducers/Navigation.reducer';
import { facetedSearch } from './Reducers/FacetedSearch.reducer';
import { checkout } from './Reducers/Checkout.reducer';
import { myPage } from './Reducers/MyPage.reducer';
import { lightboxImages } from './Reducers/LightboxImages.reducer';
import { variantTable } from './Reducers/VariantTable.reducer';
import { organizationSearch } from './Reducers/OrganizationSearch.reducer';
import { favorites } from './Reducers/Favorites.reducer';
import { app as appReducer } from './Reducers/App.reducer';
export const staticReducers = {
    app: appReducer,
    cart,
    bulkAddToCart,
    quickSearch,
    navigation,
    facetedSearch,
    checkout,
    myPage,
    lightboxImages,
    variantTable,
    organizationSearch,
    favorites,
};
export const app = combineReducers(staticReducers);
export const createReducer = (asyncReducers = {}) => {
    return combineReducers({
        ...staticReducers,
        ...asyncReducers,
    });
};
export default app;
